// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"escrowFee_mainHeading__jBiHP","fieldWrapper":"escrowFee_fieldWrapper__2TITZ","label":"escrowFee_label__3oc6B","buttonWrapper":"escrowFee_buttonWrapper__3KDde"};